import React, { FC } from 'react'
import { SingleSelectComboboxObject } from '../../../../../legacy-design-system/combobox'
import { FormProjectField, ProjectField } from '../../api/shared'
import { isUnsupportedJiraField } from './jira-field-default-value'
import { useIntl } from 'react-intl'

interface JiraFieldProps {
  field: FormProjectField
  fieldFormIndex: number
  selectableFields: ProjectField[]
  updateFieldSelection: (index: number, field: ProjectField) => void
}
export const JiraField: FC<JiraFieldProps> = ({
  field,
  fieldFormIndex,
  selectableFields,
  updateFieldSelection
}) => {
  const intl = useIntl()
  return (
    <SingleSelectComboboxObject<ProjectField>
      items={[
        {
          //  This conditional is due to the selected item not being shown in the list and needing to
          //  filter out the selection options based off other JiraField component selections
          items: field._projectField
            ? [field._projectField, ...selectableFields]
            : selectableFields
        }
      ]}
      value={field._projectField}
      onChange={(item) => updateFieldSelection(fieldFormIndex, item)}
      itemToString={(item) =>
        `${
          isUnsupportedJiraField(item)
            ? intl.formatMessage(
                {
                  id: 'detail_integrationSettings_unsupportedField_react'
                },
                { value: item.name }
              )
            : item.name
        }`
      }
      disabled={field._projectField && field._projectField.required}
      itemIsDisabled={(item) => isUnsupportedJiraField(item)}
    />
  )
}
